export const SOCKET_ENDPOINTS = {
    QUOTE_V1: '/ws/quote/v1',
    USER: '/api/ws/user',
};
